<template>
	<div class="sum_item">
		<div class="sum_box">
			<div class="money_info">
				<div class="sum_money">
					投注金额<label><input type="text" v-model="value" /></label>
				</div>
				<slot name="money"></slot>
			</div>
			<div class="select_money">
				<a href="javascript:void(0)" v-for="(item, index) in moneyData" :key="index" @click="onclickMoney(item, index)">
					<img :src="item.bgUrl" alt="" />
				</a>
			</div>
			<div class="user_btn_box">
				<el-button type="primary" @click="clearFun">清空</el-button>
				<el-button type="primary" plain @click="betFun">一键投注</el-button>
			</div>
		</div>
		<div></div>
	</div>
</template>

<script>
import img1 from "../../static/img/bottom/icon_lhc_chips10.webp";
import img2 from "../../static/img/bottom/icon_lhc_chips50.webp";
import img3 from "../../static/img/bottom/icon_lhc_chips100.webp";
import img4 from "../../static/img/bottom/icon_lhc_chips500.webp";
import img5 from "../../static/img/bottom/icon_lhc_chips1000.webp";

export default {
	name: "sumItem",
	data() {
		return {
			value: "",
			moneyData: [
				{ text: 10, checked: false, bgUrl: img1 },
				{ text: 50, checked: false, bgUrl: img2 },
				{ text: 100, checked: false, bgUrl: img3 },
				{ text: 500, checked: false, bgUrl: img4 },
				{ text: 1000, checked: false, bgUrl: img5 },
			],
		};
	},
	watch: {
		value() {
			this.value = parseInt(this.value.toString().replace(/[^\d]/g, ""));
			if (this.value > 0) {
				this.$emit("returnSelectNum", this.value);
			} else {
				this.value = "";
				this.$emit("returnSelectNum", 0);
			}
		},
	},
	methods: {
		//快捷输入
		onclickMoney(data, index) {
			this.value = data.text;
		},
		//清除功能
		clearFun() {
			this.$emit("returnClearFun");
			this.value = "";
			this.moneyData.forEach(item => {
				item.checked = false;
			});
		},
		//投注功能
		betFun() {
			this.$emit("returnBetFun");
			this.clearFun(); // 点击"一键投注"后 清空已经选择的金额
		},
	},
};
</script>

<style lang="scss" scoped>
.sum_item {
	width: 100%;
	padding: 26px 0px 0px;

	.sum_box {
		display: flex;
		justify-content: space-between;
		align-items: start;
		.money_info {
			width: 210px;
		}

		.sum_money {
			display: flex;
			white-space: nowrap;
			font-size: 14px;
			height: 35px;
			color: #555;
			align-items: center;
			border-radius: 3px;
			// box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
			// background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);
			padding-left: 13px;
			label {
				margin-left: 10px;
				input {
					width: 86%;
					height: 35px;
					padding: 0 10px;
					border-radius: 5px;
					border: solid 1px #e4e4e4;
					background-color: #fff;
					// box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
					// background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);
					// box-shadow: inset 3px 0 6px 0 rgba(0, 0, 0, 0.15);
				}
			}
		}

		.select_money {
			display: flex;

			a {
				display: block;
				width: 60px;
				height: 60px;
				margin: 0 5px;
				border-radius: 100%;

				& > img {
					width: 100%;
					height: 100%;
					border-radius: 100%;
					transition: 0.4s;
				}

				&:hover {
					img {
						transform: rotate(360deg);
					}
				}
			}
		}

		.sum_fun {
			display: flex;
			justify-content: center;

			div {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 119px;
				height: 40px;
				margin: 0 5px;
				font-size: 14px;
				border-radius: 20px;
				cursor: pointer;

				span {
					font-size: 20px;
					margin-right: 5px;
				}
			}

			.delete_bth {
				color: #999999;
				background-color: #e6e6e6;
			}

			.add_bth {
				color: #ffffff;
				background-color: #ec362b;
			}
		}
		.user_btn_box {
			.el-button--primary.is-plain::before {
				content: "一键投注";
			}

			.el-button--primary.is-plain {
				background: none;
				border: 1.5px solid #66bcfc;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/lhc/sumItem.vue